import { HelperFunction } from './FunctionTypes'
import { AbsFunction } from './definitions/AbsFunction'
import { AnySelectedFunction } from './definitions/AnySelectedFunction'
import { BMIInterpretationFunction, IsBMIFunction } from './definitions/BMIFunctions'
import { BPDiastolicFunction, BPIsElevatedFunction, BPSystolicFunction } from './definitions/BPFunctions'
import { ChangedFunction } from './definitions/ChangedFunction'
import { ConceptIdFunction } from './definitions/ConceptIdFunction'
import { DirIdFunction, DirValueIdFunction } from './definitions/DirFunctions'
import { DirValidityFunction } from './definitions/DirValidityFunction'
import { HasAnyValueFunction } from './definitions/HasAnyValueFunction'
import { IsComorbidFunction } from './definitions/IsComorbidFunction'
import { IsPcpFunction } from './definitions/IsPcpFunction'
import { PowerFunction } from './definitions/PowerFunction'
import { RoundFunction } from './definitions/RoundFunction'
import { SubconceptIdsFunction } from './definitions/SubconceptIdsFunction'
import { TitlesFunction } from './definitions/TitlesFunction'
import { ValueFunction } from './definitions/ValueFunction'

export const helperFunctions: HelperFunction[] = [
	AbsFunction,
	AnySelectedFunction,
	BMIInterpretationFunction,
	BPDiastolicFunction,
	BPIsElevatedFunction,
	BPSystolicFunction,
	ChangedFunction,
	ConceptIdFunction,
	DirIdFunction,
	DirValidityFunction,
	DirValueIdFunction,
	HasAnyValueFunction,
	IsBMIFunction,
	IsComorbidFunction,
	IsPcpFunction,
	PowerFunction,
	RoundFunction,
	SubconceptIdsFunction,
	TitlesFunction,
	ValueFunction,
]
